module.exports = __webpack_public_path__ + "static/media/map.ce221a30.png";